import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-purpl-table-comment',
  templateUrl: './purpl-table-comment.component.html',
  styleUrls: ['./purpl-table-comment.component.scss'],
})
export class PurplTableCommentComponent implements OnInit {
  @Input() label?: string;

  constructor() {}

  ngOnInit(): void {}
}
